import React, { Component } from 'react';
import SiteConfig from './SiteConfig';

// All supported languages
const LANGUAGES = [
  { code: 'th', label: 'ภาษาไทย',      labelShort: 'TH', img: 'https://flagcdn.com/w40/th.png' },
  { code: 'en', label: 'English',       labelShort: 'EN', img: 'https://flagcdn.com/w40/gb.png' },
  { code: 'zh', label: '中文',           labelShort: 'ZH', img: 'https://flagcdn.com/w40/cn.png' },
  { code: 'ja', label: '日本語',         labelShort: 'JP', img: 'https://flagcdn.com/w40/jp.png' },
  { code: 'my', label: 'မြန်မာဘာသာ',    labelShort: 'MY', img: 'https://flagcdn.com/w40/mm.png' },
  { code: 'lo', label: 'ພາສາລາວ',       labelShort: 'LO', img: 'https://flagcdn.com/w40/la.png' },
];

/**
 * LanguageSwitcher — shows current language as a pill button.
 * On click opens a modal popup with all 6 language options.
 *
 * Props:
 *   language  {string}   current lang code
 *   onChange  {function} called with new lang code
 *   size      {'sm'|'md'} default 'md'
 */
class LanguageSwitcher extends Component {
  state = { open: false };

  handleOpen  = () => this.setState({ open: true });
  handleClose = () => this.setState({ open: false });

  handleSelect = (code) => {
    localStorage.setItem('lang', code);
    if (this.props.onChange) this.props.onChange(code);
    this.setState({ open: false });
  };

  render() {
    const { language = 'th', size = 'md', allowedLangs: propAllowedLangs } = this.props;
    const allowedLangs = propAllowedLangs != null ? propAllowedLangs : (SiteConfig && SiteConfig.AllowedLangs);
    const { open } = this.state;
    const isSmall = size === 'sm';

    // กรองเฉพาะภาษาที่อนุญาต (ถ้าไม่ส่ง prop = แสดงทั้งหมด)
    const visibleLangs = allowedLangs && allowedLangs.length > 0
      ? LANGUAGES.filter((l) => allowedLangs.includes(l.code))
      : LANGUAGES;

    const current = visibleLangs.find((l) => l.code === language) || visibleLangs[0];

    /* ── trigger pill ── */
    const pillStyle = {
      display:        'inline-flex',
      alignItems:     'center',
      gap:            8,
      cursor:         'pointer',
      padding:        isSmall ? '5px 10px' : '7px 14px',
      borderRadius:   24,
      border:         '2px solid rgba(245,197,24,0.6)',
      background:     'rgba(245,197,24,0.10)',
      transition:     'all 0.2s',
      userSelect:     'none',
    };
    const pillImgStyle = {
      width:        isSmall ? 22 : 28,
      height:       isSmall ? 15 : 19,
      borderRadius: 3,
      objectFit:    'cover',
      boxShadow:    '0 1px 4px rgba(0,0,0,0.45)',
    };
    const pillLabelStyle = {
      color:      '#f5c518',
      fontWeight: 700,
      fontSize:   isSmall ? 11 : 13,
    };
    const pillArrowStyle = {
      color:    '#f5c518',
      fontSize: isSmall ? 10 : 11,
      marginLeft: 2,
    };

    /* ── modal backdrop ── */
    const backdropStyle = {
      position:        'fixed',
      inset:           0,
      background:      'rgba(0,0,0,0.65)',
      backdropFilter:  'blur(4px)',
      WebkitBackdropFilter: 'blur(4px)',
      zIndex:          99999,
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'center',
    };

    /* ── modal card ── */
    const modalStyle = {
      background:   'linear-gradient(145deg,#1a1a2e,#16213e)',
      border:       '1px solid rgba(245,197,24,0.3)',
      borderRadius: 18,
      padding:      '24px 20px 20px',
      width:        320,
      maxWidth:     '92vw',
      boxShadow:    '0 16px 48px rgba(0,0,0,0.7)',
      position:     'relative',
    };

    const modalTitleStyle = {
      color:        '#f5c518',
      fontWeight:   700,
      fontSize:     16,
      textAlign:    'center',
      marginBottom: 18,
      letterSpacing: '0.03em',
    };

    const closeBtnStyle = {
      position:   'absolute',
      top:        12,
      right:      14,
      cursor:     'pointer',
      color:      '#aaa',
      fontSize:   20,
      lineHeight: 1,
      padding:    '0 4px',
    };

    /* ── language grid ── */
    const gridStyle = {
      display:             'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap:                 10,
    };

    const itemStyle = (active) => ({
      display:       'flex',
      flexDirection: 'column',
      alignItems:    'center',
      gap:           6,
      cursor:        'pointer',
      padding:       '10px 6px',
      borderRadius:  12,
      border:        active ? '2px solid #f5c518' : '2px solid rgba(255,255,255,0.08)',
      background:    active ? 'rgba(245,197,24,0.15)' : 'rgba(255,255,255,0.05)',
      transition:    'all 0.18s',
    });

    const itemImgStyle = {
      width:        36,
      height:       24,
      borderRadius: 4,
      objectFit:    'cover',
      boxShadow:    '0 2px 6px rgba(0,0,0,0.4)',
    };

    const itemShortStyle = (active) => ({
      color:      active ? '#f5c518' : '#bbb',
      fontWeight: active ? 700 : 500,
      fontSize:   11,
      letterSpacing: '0.05em',
    });

    const itemLabelStyle = (active) => ({
      color:    active ? '#fff' : '#999',
      fontSize: 10,
      textAlign:'center',
      lineHeight: 1.2,
    });

    return (
      <>
        {/* Trigger pill */}
        <div style={pillStyle} onClick={this.handleOpen}>
          <img
            src={current.img}
            alt={current.label}
            style={pillImgStyle}
            onError={(e) => { e.target.style.display = 'none'; }}
          />
          <span style={pillLabelStyle}>{current.label}</span>
          <span style={pillArrowStyle}>▾</span>
        </div>

        {/* Modal popup */}
        {open && (
          <div style={backdropStyle} onClick={this.handleClose}>
            <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
              {/* Close button */}
              <span style={closeBtnStyle} onClick={this.handleClose}>✕</span>

              {/* Title */}
              <div style={modalTitleStyle}>🌐 เลือกภาษา / Select Language</div>

              {/* Language grid */}
              <div style={gridStyle}>
                {visibleLangs.map((lang) => {
                  const active = language === lang.code;
                  return (
                    <div
                      key={lang.code}
                      style={itemStyle(active)}
                      onClick={() => this.handleSelect(lang.code)}
                    >
                      <img
                        src={lang.img}
                        alt={lang.label}
                        style={itemImgStyle}
                        onError={(e) => { e.target.style.display = 'none'; }}
                      />
                      <span style={itemShortStyle(active)}>{lang.labelShort}</span>
                      <span style={itemLabelStyle(active)}>{lang.label}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}

export default LanguageSwitcher;
